import { render, staticRenderFns } from "./CreateSection.vue?vue&type=template&id=7dc9fa7a&scoped=true"
import script from "./CreateSection.vue?vue&type=script&lang=js"
export * from "./CreateSection.vue?vue&type=script&lang=js"
import style0 from "./CreateSection.vue?vue&type=style&index=0&id=7dc9fa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc9fa7a",
  null
  
)

export default component.exports